module.exports = __webpack_public_path__ + "img/qp_icon--white.6aef2264.svg";